


















import { Component, Mixins } from "vue-property-decorator";
import { Alert } from "@/models";
import AlertEditor from "@/components/AlertEditor.vue";
import AlertMixin from "@/mixins/http/Alert";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";

const REQUEST_TAG = "alert";

@Component({
  components: {
    AlertEditor,
    PageGuide,
  },
})
export default class AlertEdit extends Mixins(AlertMixin) {
  alert: Alert | null = null;

  busy = false;

  guidePath = GuidePaths.ALERT_FEED;

  async created() {
    this.busy = true;

    try {
      this.alert = await this.getAlert(this.$route.params.id, REQUEST_TAG);
    } finally {
      this.busy = false;
    }
  }

  cancel() {
    this.$router.go(-1);
  }

  protected onSaved() {
    this.$router.push({ name: "AlertList" });
  }
}
